export default __webpack_public_path__ + "static/media/pinkbg.2e939e0d.svg";